export const META_KEYWORDS =
  'collectibles, anotoys, toys, nft, Collectiverse, blockchain, celebrity, artist, collections, digital';
export const META_AUTHOR = 'anotoys';

export const META_FB_DOMAIN = '774x3pbfi8u2g1cwtabwz5qnhdvm68';
